import * as buttons from 'smg/buttons';
import * as errors from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import * as object from 'smg/object';
import { Phone } from 'smg/phone';
import QueryString from 'smg/querystring';
import { SafeReturnPath } from 'smg/url';
import { Relref } from '../hugo';
import { PromptLoginCode } from '../login';

main();

function main() {
    const returnTo = QueryString().get('return');
    const landingPage = SafeReturnPath(returnTo, Relref('/dashboard'));

    InitGoogleCredentialHandler(landingPage);

    if (returnTo) {
        const encoded = encodeURIComponent(landingPage);
        const $createAccount = document.querySelector('#create-account-link') as HTMLAnchorElement;
        $createAccount.href = `${Relref('/join')}?return=${encoded}`;
        const $emailLogin = document.querySelector('#login-email-link') as HTMLAnchorElement | null;
        if ($emailLogin) {
            $emailLogin.href = `${Relref('/login-email')}?return=${encoded}`;
        }
    }

    const phone = document.querySelector('#phone') as HTMLInputElement;
    setTimeout(() => phone.focus());

    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const heading = form.querySelector('h1') as HTMLHeadElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email' | 'email-unverified') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        heading.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const p = new Phone(phone);

    form.noValidate = true;
    form?.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity(form)) {
            return false;
        }

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        const prompt = await PromptLoginCode({ phone: p });

        void prompt.createCode.finally(() => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);
        });

        prompt.login.
            then(() => window.location.href = landingPage).
            catch(err => {
                if (object.IsObject(err) &&
                    object.HasKey(err, 'response') &&
                    object.IsObject(err['response']) &&
                    object.HasKey(err['response'], 'status') &&
                    errors.IsParamErrors(err['response']['data'])) {
                    if (errors.IsAxiosError(err) && errors.IsBindErrors(err.response?.data) && 'phone' in err.response.data) {
                        errors.ShowError(err);
                    } else {
                        showAlert('generic');
                    }
                }

                throw err;
            });
    });

    const googleBtn = document.querySelector('#google-cover-btn') as HTMLElement;

    googleBtn.addEventListener('click', () => {
        const hiddenGoogleBtn = document.querySelector('.g_id_signin') as HTMLElement;
        const googleTarget = hiddenGoogleBtn.querySelector('div[tabindex="0"]') as HTMLElement;

        googleTarget.dispatchEvent(new PointerEvent('click'));
    });
}
